/** author：胡枭 */

import { getCompanyInfoApi, getGrayReleaseApi } from '@/api/company.js'
import { platformTitleDict, platformFunctionModuleDict } from '@/dictionary/system'
// 后端api
import {
  getRiskRulesCodesApi
} from '@/api/risk/manage'

const state = {
  companyId: '', // 公司 ID
  companyType: '', // 公司类型
  companyName: '', // 公司名称
  socialCreditCode: '', // 统一社会信用代码
  logo: '', // 公司LOGO
  acronyms: '', // 公司简称
  isSupplier: '', // 是否为供应商 0: 否 1: 是
  isPurchaser: '', // 是否为采购人 0:否 1: 是
  isAgency: '', // 是否为代理机构 0: 否 1: 是
  isCertified: '', // 是否认证 0: 否 1: 是
  isThirdSyncData: false, // 是否为第三方推送过来的公司数据，当前的判断方式是，公司未认证但是有服务字段
  companyStatus: '', // 公司状态 0：禁用 1：正常
  companyHierarchy: [], // 公司层级
  supervise: false, // 公司受到监管：true 公司未受监管：false
  chargeConfig: [], // 企业计费配置
  rightRange: '0000', // 权限的使用范围

  // 平台配置
  workbenchName: '', // 云采购平台名称，若为空则使用默认规则
  workbenchColor: undefined, // 云采购平台的主题颜色，主要为了默认色也可以触发监听
  loginPage: '', // 登录平台地址

  // 灰度配置（包含路由和页面灰度配置）
  greyFeatures: [], // 灰度配置结果

  // 在线签章授权书审核状态
  ESignAuditsStatus: '',

  // 权限信息
  permissionInfo: [],

  riskRulesCodes: [], // 风险规则code
}

const getters = {
  // 系统登录平台地址
  loginAddress(state) {
    // 运营平台配置的登录平台地址
    if (state.loginPage) return state.loginPage
    // 受监管企业的登录平台地址
    if (state.supervise) return process.env.VUE_APP_GZ_PASSPORT_URL
    // 云采购平台默认登录平台地址
    return process.env.VUE_APP_PASSPORT_URL
  },

  // 云平台的标签页平台名称
  platformTitle(state) {
    // 运营平台配置的平台名称
    if (state.workbenchName) return state.workbenchName
    // 受监管企业的平台名称
    if (state.supervise) return platformTitleDict.GZ.label
    // 默认的平台名称
    return platformTitleDict.JCZH.label
  },

  // 平台配置
  platformConfig(state, getter) {
    return (
      platformTitleDict.array.filter(
        platform => platform.label === getter.platformTitle
      )[0] || platformTitleDict.JCZH
    )
  },

  // TODO 会根据菜单结构变动 —— 当前账号 项目详情 是否有风险关联记录
  isRiskMenuPermission(state, getters, rootState) {
    const isJxic = getters.platformTitle === platformTitleDict.JXIC.label

    // 平台角色是否包含 风险治理
    if (!rootState.router.systemRolesList.includes(platformFunctionModuleDict.RISK_GOVERNMENT.right)) {
      return false
    }

    if (rootState.user.isAdmin || rootState.user.roles.includes(platformFunctionModuleDict.RISK_GOVERNMENT.right)) {
      return true
    }

    if (isJxic && rootState.user.roles.includes(platformFunctionModuleDict.QUERY_STATS.right)) {
      return true
    }

    return false
  }
}

const mutations = {
  SET_COMPANY_ID: (state, id) => {
    state.companyId = id
  },
  SET_COMPANY_TYPE: (state, companyType) => {
    state.companyType = companyType
  },
  SET_COMPANY_NAME: (state, companyName) => {
    state.companyName = companyName
  },
  SET_COMPANY_SOCIALCODE: (state, socialCreditCode) => {
    state.socialCreditCode = socialCreditCode
  },
  SET_COMPANY_LOGO: (state, logo) => {
    state.logo = logo
  },
  SET_COMPANY_ACRONYMS: (state, acronyms) => {
    state.acronyms = acronyms
  },
  SET_COMPANY_IS_SUPPLIER: (state, isSupplier) => {
    state.isSupplier = isSupplier
  },
  SET_COMPANY_IS_PURCHASER: (state, isPurchaser) => {
    state.isPurchaser = isPurchaser
  },
  SET_COMPANY_IS_AGENCY: (state, isAgency) => {
    state.isAgency = isAgency
  },
  SET_COMPANY_IS_CERTIFIED: (state, isCertified) => {
    state.isCertified = isCertified
  },
  SET_COMPANY_IS_THIRD_DATA: (state, isThirdSyncData) => {
    state.isThirdSyncData = isThirdSyncData
  },
  SET_COMPANY_STATUS: (state, status) => {
    state.companyStatus = status
  },
  SET_COMPANY_HIERARCHY: (state, companyHierarchy) => {
    state.companyHierarchy = companyHierarchy
  },
  SET_COMPANY_SUPERVISE: (state, supervise) => {
    state.supervise = supervise
  },

  // 联系人信息
  SET_CONTACT_NAME: (state, contactName) => {
    state.contactName = contactName
  },
  SET_CONTACT_TEL: (state, contactTel) => {
    state.contactTel = contactTel
  },
  SET_CONTACT_EMAIL: (state, contactEmail) => {
    state.contactEmail = contactEmail
  },

  // 收费配置
  SET_CHARGE_CONFIG: (state, chargeConfig) => {
    state.chargeConfig = chargeConfig
  },

  // 设置权限的使用范围
  SET_RIGHT_RANGE: (state, rightRange) => {
    state.rightRange = rightRange
  },

  // 设置平台名称
  SET_WORKBENCH_CONFIG: (state, setting) => {
    state.workbenchName = setting?.workbenchName || ''
    state.workbenchColor = setting?.workbenchColor || ''
    state.loginPage = setting?.loginPage || ''
  },

  // 存储当前灰度设置
  SET_GREY_FEATURE: (state, greyFeatures) => {
    state.greyFeatures = [...state.greyFeatures, ...(greyFeatures || [])]
  },

  // 在线签章授权书审核状态
  SET_ESIGN_AUDITS_STATUS: (state, ESignAuditsStatus) => {
    state.ESignAuditsStatus = ESignAuditsStatus
  },

  // 设置公司权限信息
  SET_PERMISSION_INFO: (state, permissionInfo) => {
    state.permissionInfo = permissionInfo
  },

  // 设置风险规则Code
  SET_RISK_RULES_CODES: (state, riskRulesCodes) => {
    state.riskRulesCodes = riskRulesCodes
  },
}

const actions = {
  getUserCompanyInfo({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getCompanyInfoApi()
        .then(res => {
          const data = res.data || {}
          const isSupplier =
            (data.isCertified && data.identityInfo?.isSupplier) || ''
          const isPurchaser =
            (data.isCertified && data.identityInfo?.isPurchaser) || ''
          const isAgency =
            (data.isCertified && data.identityInfo?.isAgency) || ''

          commit('SET_COMPANY_ID', data.companyId)
          commit('SET_COMPANY_TYPE', data.type)
          commit('SET_COMPANY_NAME', data.companyName)
          commit('SET_COMPANY_SOCIALCODE', data.socialCreditCode)
          commit('SET_COMPANY_LOGO', data.companyInfo?.logo || '')
          commit('SET_COMPANY_ACRONYMS', data.companyInfo?.acronyms || '')
          commit('SET_COMPANY_IS_SUPPLIER', isSupplier)
          commit('SET_COMPANY_IS_PURCHASER', isPurchaser)
          commit('SET_COMPANY_IS_AGENCY', isAgency)
          commit('SET_COMPANY_IS_CERTIFIED', data.isCertified)
          commit(
            'SET_COMPANY_IS_THIRD_DATA',
            !data.isCertified && (isSupplier || isPurchaser || isAgency)
          )
          commit('SET_COMPANY_STATUS', data.status)
          if (data?.parentInfo?.hierarchy) {
            const arr = data?.parentInfo?.hierarchy.split(',').filter(item => {
              if (item) {
                return item
              }
            })
            commit('SET_COMPANY_HIERARCHY', arr)
          }
          commit('SET_COMPANY_SUPERVISE', data.stateOwnedSupervise)
          commit('SET_CHARGE_CONFIG', data.chargeConfig || [])
          commit('SET_WORKBENCH_CONFIG', data.setting || {})
          commit(
            'SET_RIGHT_RANGE',
            `${data.isCertified || 0}${isPurchaser || 0}${isAgency ||
              0}${isSupplier || 0}`
          )
          commit('SET_PERMISSION_INFO', data.permissionInfo || [])

          resolve({
            isCertified: data.isCertified,
            isSupplier,
            isPurchaser,
            isAgency,
            companyType: data.type,
            companyId: data.companyId,
            parentId: data.parentInfo.parentId || 0,
            supervise: data.stateOwnedSupervise,
            menus: data.menus || [],
            platformAlias: data?.setting?.workbenchName
              ? platformTitleDict.array.find(
                dict => dict.label === data.setting.workbenchName
              )?.value
              : platformTitleDict.JCZH.value,
            isJxic:
              data?.setting?.workbenchName === platformTitleDict.JXIC.label
          })
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 获取用户灰度设置
  getGrayRelease({ commit, state }) {
    return new Promise((resolve, reject) => {
      getGrayReleaseApi()
        .then(res => {
          const data = res?.data || []
          commit('SET_GREY_FEATURE', data)
          resolve(data)
        })
        .catch(err => {
          resolve([])
        })
    })
  },

  // 获取用户是否有某个特定灰度
  showGreyFeature({ state }, { code, id }) {
    return new Promise(resolve => {
      const companyId = id || state.companyId
      const feature = state.greyFeatures.find(el => el.code === code) || {}
      const hasFeature = (feature.companyIds || []).includes(companyId)
      resolve(hasFeature)
    })
  },

  // 获取风险规则
  getRiskRulesCodes({ commit, state }) {
    return new Promise((resolve, reject) => {
      getRiskRulesCodesApi()
        .then(res => {
          const data = res?.data || []
          const codes = data.map(item => {
            return {
              label: item.name,
              value: item.code
            }
          })
          commit('SET_RISK_RULES_CODES', codes)
          resolve(codes)
        })
        .catch(err => {
          resolve([])
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
